import { Radio } from "@mantine/core";

const JobTypeSelector = ({ value, onChange }) => (
  <div className="w-full mb-4 col-span-full">
    <div className="mb-1 text-sm font-medium text-gray-700">
      Job Type <span className="text-red-500">*</span>
    </div>
    <Radio.Group value={value} onChange={onChange} required>
      <div className="flex flex-wrap gap-4">
        <Radio value="permanent" label="Permanent" />
        <Radio value="part-time" label="Part-time" />
      </div>
    </Radio.Group>
  </div>
);

export default JobTypeSelector;
